<div class="row">
  <div class="br-menu" [ngClass]="{'active': showMenu}" id="main-navigation">
    <div class="menu-container">
      <div class="menu-panel col-sm-4 col-lg-3">
        <div class="menu-header">
          <div class="menu-title">
            <img [src]="logo" alt="Imagem ilustrativa" />
            <span>{{ title }}</span>
          </div>
          <div class="menu-close">
            <button
              class="br-button circle"
              type="button"
              aria-label="Fechar o menu"
              data-dismiss="menu"
              (click)="toggle()"
            >
              <i class="fas fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <nav class="menu-body" role="tree">
          @for (item of data; track item.label) {
          <div class="menu-folder" [ngClass]="{'active': item.active}">
            <a
              class="menu-item"
              href="javascript: void(0)"
              [ngClass]="{'hide': item.hide, 'disabled': item.disabled}"
              (click)="onClickItem(item, null)"
              role="treeitem"
              [attr.aria-selected]="!!item.active"
            >
              <span class="icon">
                <i
                  class="fas"
                  [ngClass]="item.icon"
                  aria-hidden="true"
                  *ngIf="item.icon"
                ></i>
              </span>
              <span class="content">{{ item.label }}</span>
              <span class="support" *ngIf="item.children.length > 0">
                <i
                  class="fas fa-chevron-down"
                  aria-hidden="true"
                  *ngIf="!item.active"
                ></i>
                <i
                  class="fas fa-chevron-up"
                  aria-hidden="true"
                  *ngIf="item.active"
                ></i>
              </span>
            </a>

            @for (sub of item.children; track sub.label) {
            <ul *ngIf="item.active">
              <li>
                <a
                  class="menu-item"
                  href="javascript: void(0)"
                  role="treeitem"
                  [attr.aria-selected]="!!sub.active"
                  [ngClass]="{'disabled': sub.disabled}"
                  (click)="onClickItem(sub, item)"
                >
                  <span class="icon">
                    <i
                      class="fas"
                      [ngClass]="sub.icon"
                      aria-hidden="true"
                      *ngIf="sub.icon"
                    ></i>
                  </span>
                  <span class="content">{{ sub.label }}</span>
                </a>

                <!-- Camada 2 -->
                <ul
                  role="group"
                  aria-label="Camada 2"
                  [ngClass]="{'active': sub.active}"
                  *ngIf="sub.children.length > 0"
                >
                  @for (s of sub.children; track s.label) {
                  <li
                    [ngClass]="{'side-menu': s.children.length > 0, 'active': s.active}"
                  >
                    <a
                      class="menu-item"
                      href="javascript: void(0)"
                      [ngClass]="{'hide': s.hide}"
                      (click)="onClickItem(s, sub)"
                      role="treeitem"
                      [attr.aria-selected]="!!s.active"
                    >
                      <span class="icon">
                        <i
                          class="fas"
                          [ngClass]="s.icon"
                          aria-hidden="true"
                          *ngIf="s.icon"
                        ></i>
                      </span>
                      <span class="content">{{ s.label }}</span>
                      <span class="support" *ngIf="s.children.length > 0">
                        <i class="fas fa-angle-right" aria-hidden="true"></i>
                      </span>
                    </a>

                    <!-- Camada 3 -->
                    <ul
                      role="group"
                      aria-label="Camada 3"
                      [ngClass]="{'active': s.active}"
                      *ngIf="s.children.length > 0"
                    >
                      @for (x of s.children; track x.label) {
                      <li>
                        <a
                          class="menu-item"
                          href="javascript: void(0)"
                          role="treeitem"
                          [attr.aria-selected]="!!x.active"
                          (click)="onClickItem(x, s)"
                        >
                          <span class="content">{{ x.label }}</span>
                        </a>
                      </li>
                      }
                    </ul>
                  </li>
                  }
                </ul>
              </li>
            </ul>
            }
          </div>
          }
        </nav>

        <div class="menu-footer">
          <div class="menu-links" *ngIf="externalLinks.length > 0">
            @for (link of externalLinks; track link.label) {
            <a [href]="link.url" target="_blank" rel="noopener">
              <span class="mr-1">{{ link.label }}</span>
              <i class="fas fa-external-link-square-alt" aria-hidden="true"></i>
            </a>
            }
          </div>

          <div class="social-network" *ngIf="socialMedia.length > 0">
            <div class="social-network-title">Redes Sociais</div>
            <div class="d-flex">
              @for (social of socialMedia; track social.url) {
              <a
                class="br-button circle"
                [href]="social.url"
                [attr.aria-label]="social.ariaLabel || 'Rede social'"
                target="_blank"
                rel="noopener"
              >
                <i
                  class="fab fa-facebook-f"
                  [ngClass]="social.icon"
                  aria-hidden="true"
                ></i>
              </a>
              }
            </div>
          </div>

          <div class="menu-info" *ngIf="menuInfo">
            <div class="text-center text-down-01">{{ menuInfo }}</div>
          </div>
        </div>
      </div>

      <div
        class="menu-scrim"
        data-dismiss="menu"
        tabindex="0"
        (click)="showMenu = !showMenu"
       role="button" (keyup.enter)="showMenu = !showMenu"></div>
    </div>
  </div>

  <div class="col">
    <div class="d-flex align-items-center">
      <div>
        <button
          class="br-button small circle"
          type="button"
          aria-label="Menu"
          data-toggle="menu"
          data-target="#main-navigation"
          (click)="toggle()"
        >
          <i class="fas fa-bars" aria-hidden="true"></i>
        </button>
      </div>
      <div class="ml-3"></div>
    </div>
  </div>
</div>
